import script from "./ModalApproval.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalApproval.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__